import { Link } from 'react-router-dom';
import React from 'react'
import config from '../../../config'
import '../../Pages/css/footer.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FaTelegramPlane, FaLinkedinIn, FaYoutube, FaFacebook, FaInstagram, FaDiscord, FaTiktok } from "react-icons/fa";
import { FaTelegram, FaXTwitter } from "react-icons/fa6";
import { SiLinktree } from "react-icons/si";

const Footer = (bg) => {
    // console.log('bg',bg.bg)
    return (<>
        <footer className={`pt-4 pb-4 ${bg.bg}`}>
            <Container>
                <Row className='align-items-center'>
                    <Col lg={4} md={12} xs={12}>
                        <div className='footer-block fs-5'>
                            <ul>
                                <li><a href={`${config.Exchange}Aboutus`} target="_blank" rel="noreferrer noopener"className='text-decoration-none'>About Us</a></li>
                                <li><a href={`${config.Exchange}Privacypolicy`} target="_blank" rel="noreferrer noopener" className='text-decoration-none'>Privacy Policy</a></li>
                                <li><a href={`${config.Exchange}faq`} target="_blank" rel="noreferrer noopener" className='text-decoration-none'>FAQ</a></li>
                            </ul>

                        </div>

                    </Col>
                    <Col lg={4} md={12} xs={12} className='mb-3'>
                    <div className='d-flex justify-content-center'>
                                <div>
                                    <p className="mb-1"><strong className='text-black'>Audited by:</strong> <a href="https://app.solidproof.io/" target="_blank" rel="noreferrer noopener" className="text-success fw-normal">SolidProofs</a></p>
                                    <p className="mb-1"><strong className='text-black'>Audit Report:</strong> <a href="https://app.solidproof.io/projects/inverted-investment" target="_blank" rel="noreferrer noopener" className="text-decoration-none text-primary fw-normal">View Report</a></p>
                                    <p className="mb-1"><strong className='text-black'>Gold Standard KYC:</strong> <span style={{ color: "#FFD700" }} className="text-warning fw-normal">Verified</span></p>
                                    <p className="mb-1"><strong className='text-black'>Security Score:</strong> <span style={{ color:"green" }} className="text-info fw-normal">83.25%</span></p>
                                </div>
                                </div>
                            </Col>
                    <Col lg={4} md={12} xs={12} className='text-right'>
                        <div className='social-icon'>
                            <ul>
                                <li>
                                    <a href='https://x.com/INFI_MultiChain'target='_blank' rel="noreferrer noopener">
                                        <FaXTwitter />
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.instagram.com/infimultichain_official/'target='_blank' rel="noreferrer noopener">
                                        <FaInstagram />
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.youtube.com/@INFIMultiChain'target='_blank' rel="noreferrer noopener">
                                        <span className='fs-5'><FaYoutube /></span>
                                    </a>
                                </li>
                                <li>
                                    <a href='https://t.me/InvertedInvestmentOfficialGroup'target='_blank' rel="noreferrer noopener">
                                        <span className='fs-5'><FaTelegram /></span>
                                    </a>
                                </li>
                                <li>
                                    <a href='https://www.linkedin.com/showcase/infi-multichain-cdex/?viewAsMember=true' target='_blank' rel="noreferrer noopener">
                                        <span className='fs-5'><FaLinkedinIn /></span>
                                    </a>
                                </li>
                            </ul>

                        </div>
                    </Col>
                </Row>
                <hr style={{color:"#000"}}/>
                <Row className=''>
                    <Col lg={7} md={6} xs={12}>
                        <div className='fs-5' >
                            <a href='mailto:support@infimultichain.com' className='me-3 text-decoration-none d-inline-block fw-normal'>support@infimultichain.com</a>
                        </div>
                    </Col>
                    <Col lg={5} md={6} xs={12} className='copyright'>
                        <a href="javascript:void(0)"className='text-decoration-none fw-normal'>© 2024 INFI MultiChain CDEX Exchange. All rights reserved.</a>
                    </Col>
                </Row>
            </Container>
        </footer>
    </>
    )
}

export default Footer